import { StoreOfferProduct } from '@common'
import cx from 'classnames'

import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'
import { useTranslatable } from '@/localization/useTranslatable'

import styles from './Heading.module.scss'

type Props = {
  product: StoreOfferProduct
}

export const Heading = ({ product }: Props) => {
  const translatable = useTranslatable()

  return (
    <div className={styles.Container}>
      <StoreTypography tag="p" style="outlined" textSize="body" className={cx(styles.Title, styles[product.game])}>
        {translatable(product.title, 'Offer')}
      </StoreTypography>
    </div>
  )
}
